const Events = require('PSEvents');

cc.Class({
    extends: cc.Component,

    properties: {
        nextButton: cc.Button,
        previousButton: cc.Button,
        label: cc.Label
    },

    onLoad () {
        this.nextButton.interactable = false;
        this.previousButton.interactable = false;
        this.nextButton.node.opacity = this.nextButton.interactable ? 255 : 100;
        this.previousButton.node.opacity = this.previousButton.interactable ? 255 : 100;
        this.label.string = '1/1';
    },

    onNextPage () {
        this.currentPage ++;
        this._onPageUpdate();
        this.node.emit('pageUpdated', this.currentPage);
    },

    onPreviousPage () {
        this.currentPage --;
        this._onPageUpdate();
        this.node.emit('pageUpdated', this.currentPage);
    },

    _onPageUpdate () {
        this.nextButton.interactable = true;
        this.previousButton.interactable = true;

        if (this.currentPage === this.totalPages) {
            this.nextButton.interactable = false;
        } 
        if (this.currentPage === 1) {
            this.previousButton.interactable = false;
        }
        this.nextButton.node.opacity = this.nextButton.interactable ? 255 : 100;
        this.previousButton.node.opacity = this.previousButton.interactable ? 255 : 100;
        this.label.string = this.currentPage + '/' + this.totalPages;
    },

    setPage (page) {
        this.currentPage = page;
        this._onPageUpdate();
    },

    setData (paging) {
        this.totalPages = Math.ceil(paging.totalCount / paging.pageSize) || 1;
        this.currentPage = 1;
        this._onPageUpdate();
    }
});
